import api from '@/_helpers/APIClient'
import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

const initialState = () => ({
  user: null,
  userId: null,
  registerUser: null,
  registerInfo: [],
  registered: true,
  invitationData: null,
  stamp_year_start_at: null
})

export const User = {
  namespaced: true,
  state: initialState,
  getters: {
    registerInfo: state => state.registerInfo,
    user: state => state.user,
    registerUser: state => state.registerUser,
    userId: state => state.userId,
    registered: state => state.registered,
    invitationData: state => state.invitationData,
    stamp_year_start_at: state => state.stamp_year_start_at
  },
  mutations: {
    UPDATE_REGISTER_INFO(state, payload) {
      state.registerInfo = payload
    },
    UPDATE_USER(state, payload) {
      state.user = payload['forms']
      state.registered = payload['registered']
      state.stamp_year_start_at = payload['detail']['stamp_year_start_at']
    },
    UPDATE_USER_DATA(state, payload) {
      state.userId = payload
    },
    RESET_STATE(state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => {
        state[key] = initial[key]
      })
    },
    SET_USER(state, item) {
      state.user = item
    },
    SET_REGISTERUSER(state, item) {
      state.registerUser = item
    },
    SET_REGISTER_RESULT(state, payload) {
      const userData = payload.user_data
      state.invitationData = payload.stamp_data
      state.userId = userData.user_id
    }
  },
  actions: {
    /**
     * アカウント登録に必要な情報（年代、職業、居住地などの表示文言とID）を取得する。
     * @param {Object} commit
     * @param {String} payload.token
     * @param {String} payload.deviceId
     * @param {String} payload.accTime
     */
    async actionFetchRegisterInfo({ commit }, payload) {
      const token = payload.token
      const deviceId = payload.deviceId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getRegisterInfo(token, accTime, deviceId)
      } else {
        res = await api.getRegisterInfo()
      }
      console.log(res.data.data.code)
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_REGISTER_INFO', res.data.data['register_data']['forms'])
      } else {
        throw res.data.data
      }
    },
    /**
     * ユーザー情報の登録
     * @param {Object} commit
     * @param {String} payload.app_token
     * @param {String} payload.device_id
     * @param {String} payload.acc_time
     * @param {String} payload.userId
     * @param {String} payload.bt_enable
     * @param {String} payload.push_enable
     * @param {String} payload.loc_enable
     * @param {String} payload.register_manage_X "X"はIDで複数件入る場合あり
     * @param {String} payload.invitation_uuid
     */
    async actionRegisterUserData({ commit }, payload) {
      let res = { data: {} }
      console.log(payload)
      if (payload.app_token !== '') {
        console.log('call inside....')
        res = await APIClient.postUserData(payload.params, payload.user)
      } else {
        console.log('保存完了しました。')
        alert('保存完了しました。APIコールしはしていません。')
        res.data['data']['code'] = '9999999'
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }

      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('SET_REGISTER_RESULT', res.data.data)
      } else {
        console.log('encount error....')
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    },
    /**
     * ユーザー情報の更新
     * @param {String} param0
     * @param {String} payload
     */
    async actionUpdateUserData({ commit }, payload) {
      let res = { data: {} }
      console.log(payload)
      if (payload.params.app_token !== '') {
        res = await APIClient.updateUserData(payload.params, payload.user)
      } else {
        console.log('保存完了しました。')
        alert('保存完了しました。APIコールしはしていません。')
        res.data['data']['code'] = '9999999'
      }

      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        const userId = res.data.data.user_data.user_id
        commit('UPDATE_USER_DATA', userId)
      } else {
        console.log('encount error....')
        throw res
      }
    },
    /**
     * ユーザー情報取得
     * @param {OBject} commit
     * @param {String} payload.token
     * @param {String} payload.userId
     * @param {String} payload.accTime
     */
    async actionFetchUserData({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getUserData(token, accTime, userId)
      } else {
        res = await api.getUserData()
      }
      console.log(res)
      console.log(res.data.data.code)
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_USER', res.data.data['user_data'])
      } else {
        throw res
      }
    }
  }
}
